
	import {
		defineComponent,
		onMounted,
		reactive
		// ref
	} from 'vue';
	import subjectList from '@/assets/data/subject.json';
	import city from '@/assets/data/city.json';
	import functionalAreas from "./components/functionalAreas.vue";
	import echart from "./components/echart.vue";
	import echartSelect from "./components/echartSelect.vue";
	export default defineComponent({
		components: {
			functionalAreas,
			echart,
			echartSelect,
		},
		setup() {
			// 声明

			let echartName1 = "学科占比统计"
			let echartData1 = [{
					value: 1048,
					name: 'Search Engine'
				},
				{
					value: 735,
					name: 'Direct'
				},
				{
					value: 580,
					name: 'Email'
				},
				{
					value: 484,
					name: 'Union Ads'
				},
				{
					value: 300,
					name: 'Video Ads'
				}
			]
			let echartName2 = "学科分数统计"
			let echartData2 = [{
					value: 1048,
					name: 'Search Engine'
				},
				{
					value: 735,
					name: 'Direct'
				},
			]
			let echartName3 = "学校占比统计"
			let echartData3 = []
			let echartName4 = "学校分数占比统计"
			let echartData4 = []
			let echartName5 = "学段占比统计"
			let echartData5 = []
			let echartName6 = "学段分数占比统计"
			let echartData6 = []
			let echartName7 = "所在区占比统计"
			let echartData7 = []
			let echartName8 = "所在区得分占比统计"
			let echartData8 = []
			let cityList = reactive({
				value: []
			});
			// 页面渲染时加载
			onMounted(() => {
				info2()
				shanghaiMap()
			})
			// 上海地区号编译
			const shanghaiMap = () => {
				cityList.value = city[0].children[0].children


			}
			// 刷新
			const refresh = (e) => {
				console.log(e)
			}
			// 查询
			const search = (e) => {
				console.log(e)
			}

			// 学科分数统计
			const info2 = (e) => {
				if (e) {
					console.log(e)
				}
			}

			// 学校分数占比统计
			const info4 = (e) => {
				if (e) {
					console.log(e)
				}
			}


			return {
				refresh,
				search,
				info2,
				info4,
				city,
				subjectList,
				echartName1,
				echartData1,
				echartName2,
				echartData2,
				echartName3,
				echartData3,
				echartName4,
				echartData4,
				echartName5,
				echartData5,
				echartName6,
				echartData6,
				echartName7,
				echartData7,
				echartName8,
				echartData8,
				shanghaiMap,
				cityList
			};
		},

	});
